import { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

const characters = [
    {
        id: "c1",
        name: "La Comptesse de Wurtenberg",
        image: "/images/Comptesse.png",
        description: "Cette femme issue de la très très vieille aristocratie qui a décidé de casser les codes pour devenir une vraie casse-cou. Même notre bon roi, un grand ami de la famille, n’a pas su la remettre sur le chemin de bienséance."
    },
    {
        id: "c2",
        name: "Hystérix la Gauloise",
        image: "/images/Hystérix.png",
        description: "Cette gauloise fière qui n’a jamais eu besoin de potion magique pour écraser ses ennemis. Elle a décidé de laisser pousser ses tresses et sa moustache tant qu’elle ne perdait pas de combats. Elles sont si longues maintenant qu’elles deviennent une arme à part entière."
    },
    {
        id: "c3",
        name: "Angela Secret",
        image: "/images/Angela.png",
        description: "Cette chevalière blanche et dorée est insupportablement irréprochable. La White Knight du ciel, elle représente le sens de l’héroïsme non sollicité."
    },
    {
        id: "c4",
        name: "Emo King",
        image: "/images/Emo.png",
        description: "Cet expert comptable qui est tombé dans le dark pendant sa crise de la trentaine en écoutant Evanescence sous la pluie. Depuis il traîne sa mélancolie autour des lacs les soirs de pleine lune."
    },
    {
        id: "c5",
        name: "Hairspray Becca",
        image: "/images/Becca.png",
        description: "Cette première de classe qui a tout lâché pour sculpter son corps de rêve et prouver qu’il n’y a pas que son cerveau qui est musclé. Elle est maintenant prête à en découdre à coup de squat jump, de chien tête en bas et de justaucorps fluo."
    },
    {
        id: "c6",
        name: "Jungle Beast",
        image: "/images/Jungle.png",
        description: "Cet homme qui a décidé qu’il serait le meilleur. Il s’entraine de jour comme de nuit. Même quand il dort, il rêve de ses entraînements. Il faut en payer le prix pour devenir le meilleur. Mais le meilleur en quoi? Ça, on ne sait pas encore."
    },
];

// ⭐ style pour limiter à 3 lignes
const descriptionStyle = (expanded) => ({
    fontSize: 13,
    color: "#ccc",
    marginTop: 6,
    lineHeight: "1.4em",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: expanded ? "unset" : 3,
    WebkitBoxOrient: "vertical"
});

export default function WinnerGameBoard() {
    const [selectedWinner, setSelectedWinner] = useState(null);
    const [firstName, setFirstName] = useState(localStorage.getItem("winner_firstName") || "");
    const [lastName, setLastName] = useState(localStorage.getItem("winner_lastName") || "");
    const [submitted, setSubmitted] = useState(localStorage.getItem("winner_submitted") === "true");
    const [expandedId, setExpandedId] = useState(null);

    const handleSubmit = async () => {
        if (!selectedWinner) return alert("Choisis un gagnant !");
        if (!firstName || !lastName) return alert("Entre ton prénom et ton nom");

        await addDoc(collection(db, "winner_predictions"), {
            winner: selectedWinner,
            first_name: firstName,
            last_name: lastName,
            date: new Date()
        });

        localStorage.setItem("winner_submitted", "true");
        localStorage.setItem("winner_firstName", firstName);
        localStorage.setItem("winner_lastName", lastName);

        setSubmitted(true);
        alert("Pari enregistré !");
    };

    if (submitted) {
        return (
            <p style={{ fontWeight: "bold", color: "red" }}>
                Merci {firstName} {lastName}, tu as déjà parié sur ce jeu !
            </p>
        );
    }

    return (
        <div style={{ padding: 16 }}>
            <p>ATTENTION : tu ne pourras parier qu'une seule fois !</p>

            <p>Qui va gagner le Royal Rumble ? 👉 Tape sur le personnage sur lequel tu paries 👇</p>

            <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(2,1fr)",
                gap: 12,
                marginBottom: 20
            }}>
                {characters.map(c => (
                    <div
                        key={c.id}
                        onClick={() => setSelectedWinner(c.id)}
                        style={{
                            border: selectedWinner === c.id ? "3px solid red" : "1px solid #ccc",
                            borderRadius: 12,
                            padding: 10,
                            cursor: "pointer",
                            textAlign: "center",
                        }}
                    >
    <img
    src={c.image}
    alt={c.name}
    style={{
        width: "100%",       // prend toute la largeur du conteneur
        height: 100,         // hauteur fixe => carré
        objectFit: "cover",  // remplit le carré sans déformation
        borderRadius: 12
    }}
/>
                        <b>{c.name}</b>

                        <p style={descriptionStyle(expandedId === c.id)}>
                            {c.description}
                        </p>

                        <span
                            onClick={(e) => {
                                e.stopPropagation();
                                setExpandedId(expandedId === c.id ? null : c.id);
                            }}
                            style={{
                                color: "#ff4fa3",
                                fontSize: 12,
                                cursor: "pointer",
                                display: "block",
                                marginTop: 4
                            }}
                        >
                            {expandedId === c.id ? "Réduire ▲" : "Lire plus ▼"}
                        </span>
                    </div>
                ))}
            </div>

            <input
                placeholder="Prénom"
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
                style={{ display: "block", marginBottom: 10, width: "100%", padding: 8, borderRadius: 6 }}
            />

            <input
                placeholder="Nom"
                value={lastName}
                onChange={e => setLastName(e.target.value)}
                style={{ display: "block", marginBottom: 10, width: "100%", padding: 8, borderRadius: 6 }}
            />

            <button
                onClick={handleSubmit}
                style={{ padding: "8px 16px", borderRadius: 6, cursor: "pointer" }}
            >
                Je parie !
            </button>
        </div>
    );
}
